import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

interface KeyboardShortcutsDialogProps {
  open: boolean;
  onClose: () => void;
}

const globalShortcuts = [
  { keys: 'Alt + 1..9', desc: 'Szybka nawigacja po głównych modułach' },
  { keys: 'f', desc: 'Fokus do wyszukiwarki (w module)' },
  { keys: '`', desc: 'Przełączanie kart/tabów w aktywnym bloku' },
  { keys: 'Cmd/Ctrl + /', desc: 'Pokaż okno skrótów klawiszowych' },
];

const estimateShortcuts = [
  { keys: 's', desc: 'Fokus do wyszukiwarki pozycji' },
  { keys: 'f', desc: 'Fokus do filtra' },
  { keys: 'Strzałki', desc: 'Nawigacja po wierszach/komórkach' },
  { keys: 'Enter / F2', desc: 'Edycja komórki' },
  { keys: 'Escape', desc: 'Wyjście z edycji/odznaczenie' },
  { keys: 'Litera w komórce', desc: 'Rozpocznij edycję od wpisanej litery' },
  { keys: 'Alt + Strzałka w prawo/lewo', desc: 'Zwijanie/rozwijanie pozycji' },
];

const KeyboardShortcutsDialog: React.FC<KeyboardShortcutsDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Skróty klawiszowe</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Typography variant="h6">Globalne</Typography>
          <List dense>
            {globalShortcuts.map((s, i) => (
              <ListItem key={i}>
                <ListItemText primary={s.keys} secondary={s.desc} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Divider />
        <Box mt={2}>
          <Typography variant="h6">Kosztorysowanie</Typography>
          <List dense>
            {estimateShortcuts.map((s, i) => (
              <ListItem key={i}>
                <ListItemText primary={s.keys} secondary={s.desc} />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">Zamknij</Button>
      </DialogActions>
    </Dialog>
  );
};

export default KeyboardShortcutsDialog; 